import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IPeriod, VeckoSchemaPerioder, WeekDayName } from "../../types/module-type";
import { IJ3_FTX_FT_BFData } from "../../types/BFDatas";
import { IModuleByggnadsdata, IModuleVentilationFTXochFT, IModuleVentilationRoundTidskanaler } from "../../types/ModuleDatas";
import notify from "devextreme/ui/notify";
import { compareNärvaroOchDrift, dayNameTranslation, minutesToString, sumSchedule } from "../TimePeriods";

export const bfl_J3_FTX_FT = (): IBFModule => {
  const bfName = BFLType.BFL_J3_FTX_FT;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    try {
      let funktionsKontroller: IKontrollResultRow[] = [];
      let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
      const debug = {} as any;

      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;
      const moduleData = module.data as IModuleVentilationFTXochFT;
      formData = (formData?.data || module.bfs?.BFL_J3_FTX_FT?.data) as IJ3_FTX_FT_BFData | undefined;

      const driftÅretRunt = moduleData.driftÅretRunt === "Ja";
      const ärVentilationStoppad = moduleData.ventilationStoppadPeriodvis === "Ja";
      moduleData.antalVeckorVentilationStoppadPerÅr = (!driftÅretRunt && ärVentilationStoppad && moduleData.antalVeckorVentilationStoppadPerÅr) || 0;

      const isFTX = module.moduleTypeId === ModuleTypeId.VentilationFTX;
      //const hasKyla = moduleData.kylbatteri !== "Kyla saknas";

      let data = {
        roundTidsKanaler: {} as any,
        export: {
          energiAnvDriftEl: 0,
          energiAnvCentralUppvärmning: 0,
          energiAnvVentilationBrutto: 0,
        },
      };
      Object.keys(module.data.tidsKanaler).forEach((k) => {
        data.roundTidsKanaler[k] = copyTidsSchema(module.data.tidsKanaler[k]);
      });

      // let tidsKanaler = moduleData.tidsKanaler as any;
      // if (formData?.harAngettNyaTidskanaler === "Ja") tidsKanaler = formData?.tidsKanaler || moduleData.tidsKanaler;
      // tidsKanaler.närvaro = moduleData.tidsKanaler?.närvaro; //Närvaro kommer alltid från ronderingen!
      const tidsKanalerComp = compareNärvaroOchDrift(moduleData.tidsKanaler?.närvaro, moduleData.tidsKanaler?.ventilation);

      if (formData?.tidsKanaler?.ventilation) {
        debug["Summor veckoscheman (Minuter)"] = {
          Närvaro: moduleData.tidsKanaler?.närvaro ? minutesToString(sumSchedule(moduleData.tidsKanaler.närvaro as VeckoSchemaPerioder, undefined)) : "?",
          Ventilation: minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, undefined)),
          "Ventilation Helfart": minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart")),
          "Ventilation Delfart": minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart")),
          "Ventilation rondering": minutesToString(sumSchedule(data.roundTidsKanaler.ventilation as VeckoSchemaPerioder, undefined)),
          "Ventilation Helfart rondering": minutesToString(sumSchedule(data.roundTidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart")),
          "Ventilation Delfart rondering": minutesToString(sumSchedule(data.roundTidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart")),
        };
      }
      if (moduleData?.tidsKanaler?.ventilation && moduleData?.tidsKanaler?.närvaro) {
        const dbgDagar = {} as any;
        Object.keys(tidsKanalerComp).forEach((e) => {
          const wdEntry = tidsKanalerComp[e];
          if (wdEntry.närvaroEjTäckt) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Närvaro ej täckt"] = minutesToString(wdEntry.närvaroEjTäckt);
          if (wdEntry.excessiveVentilation) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Ventilation utanför närvaro"] = minutesToString(wdEntry.excessiveVentilation);
        });
        debug["Kontroll veckodagar"] = dbgDagar;
      }

      //Tabell 1
      //=IF(B4='Grunddata IN'!BJ16;0;(ftx_tempTillLuftEfterÅtervinningsBat-ftx_tempUteleuft)/(ftx_tempFrånLuftInnanÅtervinningsBat-ftx_tempUteleuft))
      const uppmättVerkningsgrad =
        module.moduleTypeId === ModuleTypeId.VentilationFTX
          ? moduleData.tempFrånLuftInnanÅtervinningsBat - moduleData.tempUteluft === 0
            ? 0
            : (moduleData.tempTillLuftEfterÅtervinningsBat - moduleData.tempUteluft) / (moduleData.tempFrånLuftInnanÅtervinningsBat - moduleData.tempUteluft)
          : 0;

      const systemtypRow = globalData.Ventilation.SystemtypÅtervinning.find((r) => r.SystemtypÅtervinning === moduleData.systemtypÅtervinningFTX);
      const ftxFörväntadVerkningsgrad = systemtypRow ? systemtypRow?.FörväntadTemperaturverkningsgrad : 0;

      const BIM_DensitetLuft = globalData.System.mapSystemParametrar.BIM_DensitetLuft;
      const BIM_Luft_Energimängd = globalData.System.mapSystemParametrar.BIM_Luft_Energimängd;
      const BIM_GradtimmarVärmeFörOrten = bimHandler.BIM_GradtimmarVärmeFörOrten;
      const BIM_Gradtimmar_Kyla_Orten = bimHandler.BIM_Gradtimmar_Kyla_Orten;
      const BIM_NormalårsTemperatur = bimHandler.normalårsTemperatur;
      const BIM_TimmarPerGrad_Värme = bimHandler.BIM_TimmarPerGrad_Värme;

      //const BIM_Vägledande_VerkninsgradAktuellVärmekälla = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      const enhetKubikmeterPerTimme = "Kubikmeter per timme (m³/h)";
      const GIN_Kylbatteri_KylaSaknas = "Kyla saknas";

      const timmarHelår = 24 * 365;
      const timmarVecka = 24 * 7;
      const veckorPerÅr = timmarHelår / timmarVecka;

      const calcTabell1BasedOnTidskanaler = (
        minuterHelfart: number = 0,
        minuterDelfart: number = 0,
        tidsKanaler?: IModuleVentilationRoundTidskanaler | undefined,
        helfartAvdrag?: number | undefined,
        delfartAvdrag?: number | undefined
      ) => {
        let ftxFlödeTilluftHelfart = moduleData.flödeTilluft; //  moduleData.flödeEnhet === enhetKubikmeterPerTimme ? moduleData.flödeTilluft / 3.6 : moduleData.flödeTilluft; //B19 : =IF(flödeEnhetFT=enhetKubikmeterPerTimme;MAX(flödeTillluftFT;G19;G20)/3,6;MAX(flödeTillluftFT;G19;G20))
        if (moduleData.flödeEnhet === "Kubikmeter per timme (m³/h)") ftxFlödeTilluftHelfart = ftxFlödeTilluftHelfart / 3.6;
        if (moduleData.flödeUppgift === "Uppgift saknas") {
          if (moduleData.flödesKanalForm === "Cirkulära") {
            const schablonCirkRow = globalData.Ventilation.KanalstorlekCirkulära.find((r) => r.KanalstorlekCirkulära === Number(moduleData.flödeFrånluftDiameter));
            ftxFlödeTilluftHelfart = schablonCirkRow ? schablonCirkRow.LiterPerSekund : 0;
          } else {
            const schablonCirkRekt = globalData.Ventilation.KanalstorlekRektangulära.find((r) => r.KanalstorlekRektangulära === moduleData.flödeKanalstorlekBxH);
            ftxFlödeTilluftHelfart = schablonCirkRekt ? schablonCirkRekt.LiterPerSekund : 0;
          }
        }

        // if (tidsKanaler) {
        //   if (helfartAvdrag) {
        //     minuterHelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart") - helfartAvdrag;
        //   } else {
        //     minuterHelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart");
        //   }
        //   if (delfartAvdrag) {
        //     minuterDelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart") - delfartAvdrag;
        //   } else {
        //     minuterDelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart");
        //   }
        // }

        const ftxAnvänderDelfart = minuterDelfart > 0 ? "Ja" : "Nej";

        const reduceratFlödeRumsdonFasta =
          moduleData.harReduceradeLuftflödeFastaRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonFasta ? moduleData.reduceratFlödeRumsdonFasta : 0;
        const reduceratFlödeRumsdonReglerbara =
          moduleData.harReduceradeLuftflödeReglerbaraRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonReglerbara ? moduleData.reduceratFlödeRumsdonReglerbara : 0;
        const ftxFlödeDelfart = ftxAnvänderDelfart === "Ja" ? Math.max(reduceratFlödeRumsdonFasta, reduceratFlödeRumsdonReglerbara) : 0;

        const ftxDrifttidHelfart = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterHelfart) / 60;
        const ftxDriftFaktorHelfart = ftxDrifttidHelfart >= 8760 ? 1 : ftxDrifttidHelfart / 8760; // B23 : =IF(ftxDrifttidHelfart>=8760;1;(ftxDrifttidHelfart)/8760)

        const ftxDrifttidDelfart = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterDelfart) / 60;
        const ftxDriftFaktorDelfart = ftxDrifttidDelfart >= 8760 ? 1 : ftxDrifttidDelfart / 8760;

        //B26 : =((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*(1-ftxFörväntadVerkningsgrad)*ftxDriftFaktorHeltid)+(ftxFlödeTilluftHelfart/1000)*ftxFlödeDelfart*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*(1-ftxFörväntadVerkningsgrad)*ftxDriftFaktorDelfart

        const ftxNormalAnvändningVärme =
          (ftxFlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * BIM_GradtimmarVärmeFörOrten * (1 - ftxFörväntadVerkningsgrad) * ftxDriftFaktorHelfart +
          (((ftxFlödeTilluftHelfart / 1000) * ftxFlödeDelfart) / 100) *
            BIM_DensitetLuft *
            BIM_Luft_Energimängd *
            BIM_GradtimmarVärmeFörOrten *
            (1 - ftxFörväntadVerkningsgrad) *
            ftxDriftFaktorDelfart;
        //B27 : =IF(kylbatteriSystemtyp='Grunddata IN'!BL22;0;((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_Gradtimmar_Kyla_Orten*ftxDriftFaktorHeltid)+((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_Gradtimmar_Kyla_Orten*ftxDriftFaktorDelfart))
        const ftxNormalAnvändningKyla =
          moduleData.kylbatteri === GIN_Kylbatteri_KylaSaknas
            ? 0
            : (ftxFlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * BIM_Gradtimmar_Kyla_Orten * ftxDriftFaktorHelfart +
              (ftxFlödeTilluftHelfart / 1000) * (ftxFlödeDelfart / 100) * BIM_DensitetLuft * BIM_Luft_Energimängd * BIM_Gradtimmar_Kyla_Orten * ftxDriftFaktorDelfart;

        const ftxGradtimmarVärme = (moduleData.kontrollmättTempRegTilluft - BIM_NormalårsTemperatur) * BIM_TimmarPerGrad_Värme; // =(ftx_kontrollmättTempRegTilluft-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme;

        const ftxAktuellEnergiAnvVentilationBrutto =
          (ftxFlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * ftxGradtimmarVärme * (1 - uppmättVerkningsgrad) * ftxDriftFaktorHelfart +
          (((ftxFlödeTilluftHelfart / 1000) * ftxFlödeDelfart) / 100) *
            BIM_DensitetLuft *
            BIM_Luft_Energimängd *
            ftxGradtimmarVärme *
            (1 - uppmättVerkningsgrad) *
            ftxDriftFaktorDelfart; // =((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxGradtimmarVärme*(1-ftxuppmättVerkningsgrad)*ftxDriftFaktorHeltid)+(ftxFlödeTilluftHelfart/1000)*ftxFlödeDelfart*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxGradtimmarVärme*(1-ftxuppmättVerkningsgrad)*ftxDriftFaktorDelfart

        const ftxGradtimmarKyla = bimHandler.getGradtimmarKyla(moduleData.kontrollmättTempRegTilluft);

        const ftxAktuellEnergiAnvKylaBrutto =
          moduleData.kylbatteri === GIN_Kylbatteri_KylaSaknas
            ? 0
            : (ftxFlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * ftxGradtimmarKyla * ftxDriftFaktorHelfart +
              (ftxFlödeTilluftHelfart / 1000) * (ftxFlödeDelfart / 100) * BIM_DensitetLuft * BIM_Luft_Energimängd * ftxGradtimmarKyla * ftxDriftFaktorDelfart; //=IF(kylbatteriSystemtyp=GIN_Kylbatteri_KylaSaknas;0;((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxGradtimmarKyla*ftxDriftFaktorHeltid)+((ftxFlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxGradtimmarKyla*ftxDriftFaktorDelfart))

        let motorEffekt = 0;
        switch (moduleData.motoreffektUppgift) {
          case "Uppmätt värde":
            motorEffekt = moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft;
            break;
          case "Driftsättningsprotokoll":
            motorEffekt = moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft;
            break;
          case "Märkskylt nominell effekt":
            motorEffekt = (moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft) * 0.8;
            break;
          case "Uppgift saknas":
            const tillverkningsårRow = globalData.Ventilation.Tillverkningsår.find((r) => r.Tillverkningsår === moduleData.tillverkningsår);
            const sfp = tillverkningsårRow ? (isFTX ? tillverkningsårRow.SFP_FTX : tillverkningsårRow.SFP_FT) : 0;
            motorEffekt = sfp * (ftxFlödeTilluftHelfart / 1000);

            break;
          default:
            throw new Error("Okänt val motoreffektUppgift: " + moduleData.motoreffektUppgift);
        }

        const ftxEnergiAnvändningDriftEl = (motorEffekt * ftxDrifttidDelfart * ftxFlödeDelfart) / 100 + motorEffekt * ftxDrifttidHelfart; //MAX((G24:G27)*ftxDrifttidDelfart*0,5)+(MAX(G24:G27)*ftxDrifttidHelfart)

        // OM central värme i byggnad är Fjärrvärme, Biobränslepanna, Gaspanna, eller oljepanna.
        // OM Värmebatteri i aggregatet INTE har central vattenburen värme.
        // Då skall energi för transmision inte subtraheras med energi från ventilationsaggregat.
        const energiKällaRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === byggnadModuleData.energikälla);

        //const ftxsubtraheraINTETransmission = byggnadModuleData.energikälla === "Direktverkande EL" ? 0 : 1; //AT26
        const ftxsubtraheraINTETransmission = energiKällaRow?.BFL_J3_FTX_FT_SubtraheraEj && moduleData.eftervärmningsbatteri !== "Central vattenburen värme" ? 1 : 0; //AT26
        const ftxenergianvändningUppvärmningFörVentilation = ftxsubtraheraINTETransmission ? 0 : ftxNormalAnvändningVärme;

        const tabell1 = {
          "8. Uppmätt temperaturverknigsgrad för ventilationsaggregatets återvinning": uppmättVerkningsgrad,
          "9. Förväntad temperaturverknigsgrad för denna formen av återvinningssystem": ftxFörväntadVerkningsgrad,
          "10. Flöde tilluft helfart (l/s)": ftxFlödeTilluftHelfart,
          "Går ventialtionsaggregat på reducerad drift under någon tidsperiod (Ja/Nej)": ftxAnvänderDelfart,
          "10. Flöde tilluft reducerad drift (%)": ftxFlödeDelfart,
          "12. Drifttid helfart i h  (X timmar/år) med befintlig tidkanal.": ftxDrifttidHelfart,
          "12. Driftfaktor (1) i %  (X timmar av 8760) med helfart tidkanal.": ftxDriftFaktorHelfart,
          "12. Drifttid delfart i h  (X timmar/år) med befintlig tidkanal.": ftxDrifttidDelfart,
          "12. Driftfaktor (2) i %  (X timmar av 8760) med delfart tidkanal.": ftxDriftFaktorDelfart,

          "Normal energianvändning värme (kWh/år). Bruttovärde för beräkning besparings potential": ftxNormalAnvändningVärme,
          "Normal energianvändning kyla (kWh/år) Bruttovärde för beräkning besparings potential": ftxNormalAnvändningKyla,
          "Gradtimmar värme för orten och aktuell °C tilluft  (Ch)": ftxGradtimmarVärme,
          "Gradtimmar kyla för orten och aktuell °C tilluft  (Ch)": ftxGradtimmarKyla,
          "Aktuell energianvändning uppvärmning / år för ventilationsaggregat. (kWh/år). Bruttovärde.": ftxAktuellEnergiAnvVentilationBrutto,
          "Aktuell energianvändning kyla / år för ventilationsaggregat. (kWh/år). Bruttovärde.": ftxAktuellEnergiAnvKylaBrutto,

          "Aktuell energianvändning drift el (kWh/år) -> BIM": ftxEnergiAnvändningDriftEl,

          "ftxenergianvändningUppvärmningFörVentilation -> BIM": ftxenergianvändningUppvärmningFörVentilation,
          // "12. Närvarotid i h  (X timmar) med befintlig verksamhet.": närvarotid,
          // "12. Närvarotid i h  (X timmar) med befintlig verksamhet inkl. efter- och för- vädring. (1+1h/dygn)": närvarotidInklFörOEfterVädring,
          // "12. Driftfaktor (3) helfart + delfart i %  (X timmar av 8760) med befintlig tidkanal.": driftFaktor3HelPlusDelfart,
          // "13. Driftfaktor (4) i %  (X timmar av 8760) för verksamhetens behov.": driftFaktor4FörVerksamhetensBehov,
          //"13. Driftfaktor (5) i %  (X timmar av 8760) för verksamhetens behov inkl. efter- och för- vädring.": driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring,
          ftxsubtraheraINTETransmission,
          motorEffekt,
          ftxAktuellEnergiAnvVentilationBrutto,
          // driftFaktor3HelPlusDelfart,
          // driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring,
          ftxAktuellEnergiAnvKylaBrutto,
          ftxEnergiAnvändningDriftEl,
          ftxenergianvändningUppvärmningFörVentilation,
        };

        return tabell1;
      };

      let tabell1 = undefined;
      let tabell1Nyatider = undefined;
      let minuterHelfart = 0;
      let minuterDelfart = 0;

      if (driftÅretRunt) {
        const minuterPerVecka = (timmarHelår * 60) / veckorPerÅr; //8760 timmar * 60 minuter / veckor per år
        const deltidsFaktor = moduleData.delfartsFaktor ? moduleData.delfartsFaktor / 100 : 0;
        minuterHelfart = minuterPerVecka * (1 - deltidsFaktor);
        minuterDelfart = minuterPerVecka * deltidsFaktor;

        tabell1 = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);
      } else {
        minuterHelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart");
        minuterDelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart");
        tabell1 = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart); //moduleData.tidsKanaler

        let tidsKanaler = formData?.tidsKanaler || moduleData?.tidsKanaler;
        minuterHelfart = sumSchedule(tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart");
        minuterDelfart = sumSchedule(tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart");
        tabell1Nyatider = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);
      }

      data.export.energiAnvVentilationBrutto = tabell1.ftxAktuellEnergiAnvVentilationBrutto;
      data.export.energiAnvDriftEl = tabell1.ftxEnergiAnvändningDriftEl;
      data.export.energiAnvCentralUppvärmning = tabell1.ftxenergianvändningUppvärmningFörVentilation;

      let dbgBIM = { BIM_DensitetLuft, BIM_Luft_Energimängd, BIM_GradtimmarVärmeFörOrten, BIM_Gradtimmar_Kyla_Orten, BIM_NormalårsTemperatur, BIM_TimmarPerGrad_Värme };

      debug["Grundvärden"] = dbgBIM;

      debug["Tabell 1 (B17:B38)"] = tabell1;
      debug["Tabell 1 Nyatider"] = tabell1Nyatider;

      const värmeBatteriSystemtyp = moduleData.eftervärmningsbatteri;
      const energikalla = byggnadModuleData.energikälla;
      const ftxEnergikälla = värmeBatteriSystemtyp === "Central vattenburen värme" ? energikalla : värmeBatteriSystemtyp; //=IF(värmeBatteriSystemtyp='Grunddata IN'!BL15;energikalla;värmeBatteriSystemtyp)
      const ftxEnergiKällaRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === ftxEnergikälla);
      const ftxEnergikällaVerkningsgrad = bimHandler.getVerkningsgradFromVärmeBatterityp(värmeBatteriSystemtyp); // ftxEnergikällaVerkningsgradRow ? ftxEnergikällaVerkningsgradRow.VägledandeVerkningsgrad : 1.01;

      debug["Tabell 2 Värme"] = { "15. System som betjänar eftervärmningsbatteri.": moduleData.eftervärmningsbatteri };

      const kylbatteriSystemtyp = moduleData.kylbatteri;

      const ftxKylform = kylbatteriSystemtyp === "Central vattenburen kyla" ? moduleData.kylform : kylbatteriSystemtyp; //=IF(kylbatteriSystemtyp='Central vattenburen kyla';kylform;kylbatteriSystemtyp)
      const kylFormRow = globalData.Ventilation.Kylform.find((r) => r.Kylform === ftxKylform);
      const ftxKylformVerkningsgrad = kylFormRow ? kylFormRow.Verkningsgrad : 1.01;

      const { ftxAktuellEnergiAnvVentilationBrutto, ftxAktuellEnergiAnvKylaBrutto, ftxEnergiAnvändningDriftEl } = tabell1;

      //Försök att bättre beräkna besparingspotential genom att skicka in optimerade värden till beräkning för energianvänding och sedan jämföra med befintliga värden.
      const totalExcessiveVentilationDelfart = Object.keys(tidsKanalerComp).reduce((agg, k) => agg + (tidsKanalerComp[k].excessiveVentilationDelfart || 0), 0);
      const totalExcessiveVentilationHelfart = Object.keys(tidsKanalerComp).reduce((agg, k) => agg + (tidsKanalerComp[k].excessiveVentilationHelfart || 0), 0);
      minuterHelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart") - totalExcessiveVentilationHelfart;
      minuterDelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart") - totalExcessiveVentilationDelfart;
      const tabell1Optimerad = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);

      const ftxBesparinspotentialVärme = tabell1.ftxAktuellEnergiAnvVentilationBrutto - tabell1Optimerad.ftxAktuellEnergiAnvVentilationBrutto;
      const ftxBesparinspotentialKyla = tabell1.ftxAktuellEnergiAnvKylaBrutto - tabell1Optimerad.ftxAktuellEnergiAnvKylaBrutto;
      const ftxBesparinspotentialDriftEl = tabell1.ftxEnergiAnvändningDriftEl - tabell1Optimerad.ftxEnergiAnvändningDriftEl;

      const ftxBesparinspotentialVärmeNetto = ftxEnergikällaVerkningsgrad === 0 ? 0 : ftxBesparinspotentialVärme / ftxEnergikällaVerkningsgrad;
      const ftxBesparinspotentialKylaNetto = ftxKylformVerkningsgrad === 0 ? 0 : ftxBesparinspotentialKyla / ftxKylformVerkningsgrad;
      const ftxBesparinspotentialDriftElNetto = ftxBesparinspotentialDriftEl;

      debug["Besparingspotential Om Optimerad"] = {
        VärmeBrutto: ftxBesparinspotentialVärme,
        KylaBrutto: ftxBesparinspotentialKyla,
        DriftElBrutto: ftxBesparinspotentialDriftEl,
        VärmeNetto: ftxBesparinspotentialVärmeNetto,
        KylaNetto: ftxBesparinspotentialKylaNetto,
        DriftElNetto: ftxBesparinspotentialDriftElNetto,
      };

      const ftxAktuellEnergiAnvVentilationBrutto_nyaTider = tabell1Nyatider?.ftxAktuellEnergiAnvVentilationBrutto || 0;
      const ftxAktuellEnergiAnvKylaBrutto_nyaTider = tabell1Nyatider?.ftxAktuellEnergiAnvKylaBrutto || 0;
      const ftxEnergiAnvändningDriftEl_nyaTider = tabell1Nyatider?.ftxEnergiAnvändningDriftEl || 0;

      const ftxVärmeNyatider = ftxAktuellEnergiAnvVentilationBrutto_nyaTider - ftxAktuellEnergiAnvVentilationBrutto;
      const ftxKylaNyatider = ftxAktuellEnergiAnvKylaBrutto_nyaTider - ftxAktuellEnergiAnvKylaBrutto;
      const ftxDriftElNyatider = ftxEnergiAnvändningDriftEl_nyaTider - ftxEnergiAnvändningDriftEl;

      debug["Förändring med nya tider"] = { ftxVärmeNyatider, ftxKylaNyatider, ftxDriftElNyatider };

      const energiSlagVärme = ftxEnergikälla === "Intern värmepump i ventilationsaggregat" ? "Värme (El)" : ftxEnergiKällaRow ? ftxEnergiKällaRow.Energislag : "?";
      const energiSlagKyla = kylFormRow ? kylFormRow.Energiform : "?";
      const ärHuvudsakligtVärmesystem = moduleData.ärHuvudsakligtVärmesystem === "Ja";

      // Funktionskontroller och driftoptimeringar
      if (driftÅretRunt) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
      } else {
        if (moduleData.finnsOrsakerTillLångDrifttid === "Ja") {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
        } else {
          if (!ärHuvudsakligtVärmesystem) {
            if (ftxBesparinspotentialVärmeNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, ftxBesparinspotentialVärmeNetto, energiSlagVärme));

            if (ftxBesparinspotentialKylaNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, ftxBesparinspotentialKylaNetto, energiSlagKyla));

            if (ftxBesparinspotentialDriftElNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, ftxBesparinspotentialDriftElNetto, "El"));
          }

          //=IF(ftxBesparingNettoElDrift<1;BFLJ3FTX_OptText4;"")
          if (ftxBesparinspotentialDriftEl < 1) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, undefined, ""));

          //Finns det överventilation för några dagar befintliga dagar?
          const overVentilationVeckodagar = [] as string[];
          Object.keys(tidsKanalerComp).forEach((e) => {
            const wdEntry = tidsKanalerComp[e];
            if (wdEntry.excessiveVentilation) overVentilationVeckodagar.push(dayNameTranslation[e as WeekDayName]);
          });
          if (overVentilationVeckodagar.length)
            funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 14, undefined, "", { formatFn: (v) => overVentilationVeckodagar.join(", ") }));
        }
        //=IF(AND(Q42+Q43+Q44>1;'Grunddata IN'!B237="Ja");BFLJ3FTX_OptText5;"")
        // if (ftxBesparinspotentialVärme + ftxBesparinspotentialKyla + ftxBesparinspotentialDriftEl > 1 && moduleData.finnsOrsakerTillLångDrifttid === "Ja")
        //   funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));

        //Saknas ventilation för några befintliga dagar?
        const avvikandeVeckodagar = [] as string[];
        Object.keys(tidsKanalerComp).forEach((e) => {
          const wdEntry = tidsKanalerComp[e];
          if (wdEntry.närvaroEjTäckt) avvikandeVeckodagar.push(dayNameTranslation[e as WeekDayName]);
        });

        if (avvikandeVeckodagar.length) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 13, undefined, "", { formatFn: (v) => avvikandeVeckodagar.join(", ") }));

        const ftxVärmeNyatiderNetto = ftxVärmeNyatider / ftxEnergikällaVerkningsgrad;
        const ftxKylaNyatiderNetto = ftxKylaNyatider / ftxKylformVerkningsgrad;
        const ftxDriftElNyatiderNetto = ftxDriftElNyatider;

        if (tabell1Nyatider && formData?.harAngettNyaTidskanaler === "Ja") {
          if (ftxVärmeNyatiderNetto > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 6, ftxVärmeNyatiderNetto, energiSlagVärme));

          if (ftxKylaNyatiderNetto > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 7, ftxKylaNyatiderNetto, energiSlagKyla));

          if (ftxDriftElNyatiderNetto > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 8, ftxDriftElNyatiderNetto, "El"));

          if (ftxVärmeNyatiderNetto < 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 9, -ftxVärmeNyatiderNetto, energiSlagVärme));

          if (ftxKylaNyatiderNetto < 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 10, -ftxKylaNyatiderNetto, energiSlagKyla));

          if (ftxDriftElNyatiderNetto < 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 11, -ftxDriftElNyatider, "El"));

          //Saknas ventilation för några nya dagar?
          const tidsKanalerCompNyaTider = compareNärvaroOchDrift(moduleData.tidsKanaler?.närvaro, formData.tidsKanaler?.ventilation);
          const avvikandeVeckodagarNyaTider = [] as string[];
          Object.keys(tidsKanalerCompNyaTider).forEach((e) => {
            const wdEntry = tidsKanalerCompNyaTider[e];
            if (wdEntry.närvaroEjTäckt) avvikandeVeckodagarNyaTider.push(dayNameTranslation[e as WeekDayName]);
          });

          if (avvikandeVeckodagarNyaTider.length)
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 12, undefined, "", { formatFn: (v) => avvikandeVeckodagarNyaTider.join(", ") }));

          //Finns det överventilation för några dagar nya dagar?
          const overVentilationVeckodagarNyaTider = [] as string[];
          Object.keys(tidsKanalerCompNyaTider).forEach((e) => {
            const wdEntry = tidsKanalerCompNyaTider[e];
            if (wdEntry.excessiveVentilation) overVentilationVeckodagarNyaTider.push(dayNameTranslation[e as WeekDayName]);
          });

          if (overVentilationVeckodagarNyaTider.length)
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 15, undefined, "", { formatFn: (v) => overVentilationVeckodagarNyaTider.join(", ") }));
        }
      }

      const bH = bflHelper.bflHelper();

      return {
        bfName: BFLType.BFL_J3_FTX_FT,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        data,
        debug,
        note: "",
      };
    } catch (err: any) {
      return {
        bfName: BFLType.BFL_J3_FTX_FT,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };

  const copyTidsSchema = (schema: VeckoSchemaPerioder): VeckoSchemaPerioder => {
    const res: Partial<VeckoSchemaPerioder> = {};
    Object.keys(WeekDayName).forEach((wd: string) => {
      res[wd as WeekDayName] = schema[wd as WeekDayName]?.slice();
    });

    return res;
  };

  /// transfers any formdata values to the bfl Result. bfl will be exposed to binding the form
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (!bfl.data) bfl.data = {};
    if (bflForm?.data?.tidsKanaler) {
      bfl.data.tidsKanaler = bflForm.data.tidsKanaler;
    }
    if (bflForm?.data?.harAngettNyaTidskanaler) {
      bfl.data.harAngettNyaTidskanaler = bflForm.data.harAngettNyaTidskanaler;
    }
    if (!bfl.data.tidsKanaler && bfl.data.roundTidsKanaler) {
      //Init default values for tidsKanaler
      bfl.data.tidsKanaler = {};
      Object.keys(bfl.data.roundTidsKanaler).forEach((k) => {
        bfl.data.tidsKanaler[k] = copyTidsSchema(bfl.data.roundTidsKanaler[k]);
      });
    }
  };

  return { bfName, getResult, bflSpecificPrepareData };
};

const dflt = { bfl_J3_FTX_FT };

export default dflt;
